import React, { useEffect } from 'react'
import { EditorContent, useEditor } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit';
import BulletList from '@tiptap/extension-bullet-list';
import OrderedList from '@tiptap/extension-ordered-list';
import Document from '@tiptap/extension-document';
import ListItem from '@tiptap/extension-list-item';
import Paragraph from '@tiptap/extension-paragraph';
import Underline from '@tiptap/extension-underline';
import { KeenIcon } from '@/components';
import { cn } from '@/lib/utils';
import TextAlign from '@tiptap/extension-text-align';

const RichTextEditor = ({ value, onChange }) => {
  const editor = useEditor({
    extensions: [
        StarterKit, 
        Document, 
        Paragraph, 
        Text, 
        BulletList, 
        OrderedList, 
        ListItem, 
        Underline,
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        })
    ],
    content: value || '',
    onUpdate: ({ editor }) => {
      const html = editor.getHTML()
      onChange?.(html)
    },
  })

  useEffect(() => {
    if (editor && value !== editor.getHTML()) {
      editor.commands.setContent(value || '')
    }
  }, [value])

  if (!editor) return null

  return (
    <div className="prose rich-text-editor input flex-col w-full shrink-0 h-full px-0">
      <div className="toolbar">
        <button type='button' 
            onClick={() => editor.chain().focus().toggleBold().run()}
            className={cn(
                'editor-btn',
                { 'is-active': editor.isActive('bold') }
            )}
            >
            <KeenIcon icon='text-bold' />
        </button>
        <button type='button' 
            onClick={() => editor.chain().focus().toggleItalic().run()}
            className={cn(
                'editor-btn',
                { 'is-active': editor.isActive('italic') }
            )}
            >
            <KeenIcon icon='text-italic' />
        </button>
        <button type='button' 
            onClick={() => editor.chain().focus().toggleUnderline().run()}
            className={cn(
                'editor-btn',
                { 'is-active': editor.isActive('underline') }
            )}
            >
            <KeenIcon icon='text-underline' />
        </button>
        <button type='button'
            onClick={() => editor.chain().focus().toggleBulletList().run()}
            className={cn(
                'editor-btn',
                { 'is-active': editor.isActive('bulletList') }
            )}
          >
            <KeenIcon icon='text-circle' />
        </button>
        <button type='button'
            onClick={() => editor.chain().focus().toggleOrderedList().run()}
            className={cn(
                'editor-btn',
                { 'is-active': editor.isActive('orderList') }
            )}
          >
            <KeenIcon icon='text-number' />
        </button>
        <button type='button'
            onClick={() => editor.chain().focus().setTextAlign('left').run()}
            className={cn('editor-btn', { 'is-active': editor.isActive({ textAlign: 'left' }) })}
            >
            Align Left
        </button>

        <button type='button'
            onClick={() => editor.chain().focus().setTextAlign('center').run()}
            className={cn('editor-btn', { 'is-active': editor.isActive({ textAlign: 'center' }) })}
            >
            Align Center
        </button>

        <button type='button'
            onClick={() => editor.chain().focus().setTextAlign('right').run()}
            className={cn('editor-btn', { 'is-active': editor.isActive({ textAlign: 'right' }) })}
            >
            Align Right
        </button>
      </div>
      <EditorContent editor={editor} className='editor-content w-full h-[150px] overflow-auto mt-2 px-0' />
    </div>
  )
}

export { RichTextEditor }